module.exports = __webpack_public_path__ + "static/media/patient.b488d326.png";